import { _ } from "libs";
import React, { useEffect, useState } from "react";
import ProfileForm from "../../components/settings/profileForm";
import withRedux from "../../withRedux";
import { RootState } from "../../reducers";
import { Profile, Sport, Ratings } from "../../types";
import AvatarUploader from "../../components/settings/avatarUploader";
import {
	refreshMyProfile,
	updateProfile,
	loadSupportedSports,
	loadRatings,
	flash,
	getPlayerProfile,
} from "../../actions";
import Loader from "../../components/loader";

type Props = {
	profile: Profile;
	refreshMyProfile: typeof refreshMyProfile;
	loadSupportedSports: typeof loadSupportedSports;
	loadRatings: typeof loadRatings;
	updateProfile: typeof updateProfile;
	sports: Sport[];
	ratings: Ratings;
};

const MyProfile = ({
	profile,
	refreshMyProfile,
	updateProfile,
	loadSupportedSports,
	loadRatings,
	sports,
	ratings,
}: Props) => {
	const [userProfile, setProfile] = useState(null);

	useEffect(() => {
		//force refreshing the profile
		if (!userProfile) {
			getPlayerProfile(profile.userId).then(p => setProfile(p));
		}
	});

	useEffect(() => {
		loadSupportedSports();
		loadRatings();
	}, [loadRatings, loadSupportedSports]);

	const onAvatarUploaded = () => {
		refreshMyProfile();
	};

	return (
		<>
			{!userProfile ? (
				<Loader />
			) : (
				<>
					{userProfile.profileManagedBy !== null && (
						<div className="msg info mt-8">
							<p>{_("profile.profileManagedBy", null, { clubName: userProfile.profileManagedBy[0] })}</p>
							<p>
								<a
									className="link"
									href="https://support.gotcourts.com/hc/de/articles/34842759855633"
									target="_blank"
									rel="noopener noreferrer"
								>
									{_("learnMore")}
								</a>
							</p>
						</div>
					)}
					<h5>{_("profilePhoto.heading")}</h5>
					<AvatarUploader
						profile={userProfile}
						onAvatarUploaded={onAvatarUploaded}
						onAvatarRemove={console.log}
					/>
					<h5>{_("profile.heading")}</h5>
					<ProfileForm
						profile={userProfile}
						sports={sports}
						ratings={ratings}
						onChange={values => {
							flash(_("form.message.saved"));
							updateProfile(values);
						}}
					/>{" "}
				</>
			)}
		</>
	);
};

export default withRedux(
	{ refreshMyProfile, updateProfile, loadSupportedSports, loadRatings },
	({ profile, utility: { sports, ratings } }: RootState) => {
		return { profile, sports, ratings };
	}
)(MyProfile);
